// Exotics widgets share PricingProvider (architect E8). Thin pass-through.
import type { FC } from 'react';

import ExoticsRiskBandWidget from './exotics-risk-band-widget';
import type { ExoticsRiskBandProps } from './types';

const ExoticsRiskBandWrapperProvider: FC<ExoticsRiskBandProps> = (props) => (
  <ExoticsRiskBandWidget {...props} />
);

export default ExoticsRiskBandWrapperProvider;
